import * as swcHelpers from '@swc/helpers';
import { DataLayer } from '@grandvisionhq/analytics';
import { mapProductToDataLayerProductObject } from '../Mappers/ProductMapper.js';

const createImpressionEvent = (product, position, location, currency)=>{
    return {
        event: 'gvProductImpressions',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                impressions: [
                    swcHelpers.objectSpread({}, mapProductToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined'), {
                        list: location,
                        position
                    }), 
                ]
            }
        }
    };
};
const createInteractionEvent = (product, position, location, currency)=>{
    return {
        event: 'gvProductClick',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                click: {
                    actionField: {
                        list: location
                    },
                    products: [
                        swcHelpers.objectSpread({}, mapProductToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined'), {
                            position
                        }), 
                    ]
                }
            }
        }
    };
};

export { createImpressionEvent, createInteractionEvent };
//# sourceMappingURL=ProductPromotionEvents.js.map
